<div>
    <h2 data-testid="adx-invoice-details-title" class="page-details-title-style">Invoice {{invoiceData.adxInvoiceId}}</h2>
</div>

<app-adx-invoice-info [data]="invoiceData"></app-adx-invoice-info>

<adx-booking-list [data]="invoiceData"></adx-booking-list>
